<template>
    <div class="view-paper-material-paper">
        <div class="title">
            {{ papername }}
        </div>
        <div class="content">
            <div class="content-container">
                <el-tabs type="border-card">
                  <el-tab-pane v-for="(item,index) in material" :key="index">
                    <span slot="label">{{ item.index }}</span>
                    <div class="materail-content" v-html="item.content">
                    </div>
                  </el-tab-pane>
            </el-tabs>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                material:"",
                papername:'',
            };
        },
        methods:{
            toChies:function(num){
                const upperNumbers= [ '一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '百', '千', '万', '亿']
                const length = String(num).length
                if (length === 1) {
                  return upperNumbers[num]
                } else if (length === 2) {
                  if (num === 9) {
                    return upperNumbers[num]
                  } else if (num > 9 && num < 19) {
                    const index = String(num)
                    return '十' + upperNumbers[index.charAt(1)]
                  } else {
                    const index = String(num)
                    if(index.charAt(1)==9){
                        return upperNumbers[index.charAt(0)] + '十'
                    }else{
                        return upperNumbers[index.charAt(0)-1] + '十' + upperNumbers[index.charAt(1)]
                    }

                  }
                } else {
                  return ''
                }
            },
            getinfo:function(){
                this.$api.GETMATERIALINFO({
                    question_id: this.$route.params.question_id,
                    tiku_paper_id: this.$route.params.tiku_paper_id
                }).then((res) => {
                    if(res.retcode==0){
                        // this.papername = res.data.paper_name;
                        this.material = res.data.map((item, index) => {
                          item.index = '材料' + this.toChies(index);
                          return item;
                        });
                    }else{
                        this.$message.error(res.message);
                    }
                })
            },
        },
        created () {
            // this.papername = window.localStorage.getItem(`exercise_name${this.$route.params.record_id}`) + ' - ' + this.$route.params.question_num;
            this.papername = this.$route.params.exercise_name + ' - ' + this.$route.params.question_num;
            this.getinfo()
        }
    }
</script>
<style lang="less" scoped>
.view-paper-material-paper {
  .title {
    padding: 10px;
    font-weight: bolder;
  }
  .content{
      padding-bottom: 0;
      line-height: 34px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/view-paper-material/index.vue